module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAABFElEQVR4Ac1RtVoDYRAc3KXBXd8Gq7EGd3epcXkC3BrcOl4A9w53d4f5v1sgoaJBNslld2ZuFb9irzvq+zCFJUfMARthGkKHIUFSgojdTUh8PYh5Eyza42VTfekwvOoTljKxeSNsR+NpSaHHlSrrXgb2c5XDkCApCigTI8Hvoi0Oy3HRjHljrHhj2Q3zZrgZJ0hKNGIX7TgownowVv1Umr106WErgu8QJEUBZXpDS2mmuRmT8LIHCzbi6w192YWDErWT1UDMGWI3SaeCCUFSFFCmP8OCFfbzcdLId5RItWeMi06CpETzuSUme5xRWU9qFMGd7MTSYUiQlGzpO3cg+PUOEjPNsjOzcicaQke7NClB/qe9ATDo1EyHXYpBAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/MK.png
// module id = 1207
// module chunks = 0